export default __webpack_public_path__ + "static/media/research-services.36aa0fe2.png";